import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import IForm from '../../../types/IForm';
import ConfigurationUpload from '../../../_lib/components/ConfigurationFileUpload/ConfigurationUpload';
import { Namespace } from '../../../translation/namespace';

type CompositionConfigurationEditProps = { form: IForm };

function CompositionConfigurationEdit({ form }: CompositionConfigurationEditProps) {
  return <ConfigurationUpload namespace={Namespace.CompositionConfiguration} name="file" form={form} />;
}

export const CompositionConfigurationEditView = asView(CompositionConfigurationEdit);
export type CompositionConfigurationEditView = ComponentProps<typeof CompositionConfigurationEditView>;
